/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_OtherInputs */

const en_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const es_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const fr_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const it_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

const pt_br2_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const pl_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inne`)
};

const hu_admin_dashboard_invoice_tags_other = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéb`)
};

/** @type {(inputs: Admin_Dashboard_Invoice_Tags_OtherInputs) => LocalizedString} */
const ro_admin_dashboard_invoice_tags_other = en_admin_dashboard_invoice_tags_other;

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Admin_Dashboard_Invoice_Tags_OtherInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_other = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_OtherInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_OtherInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_other(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_other(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_other(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_other(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_other(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_other(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_other(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_other(inputs)
	return ro_admin_dashboard_invoice_tags_other(inputs)
});
export { admin_dashboard_invoice_tags_other as "admin.dashboard.invoice_tags.other" }